import React, { useState, useEffect } from 'react';

// Static mapping of all API avatar IDs to their SVG URLs
export const AVATAR_MAP = {
  gamepad: 'https://openmoji.org/data/color/svg/1F3AE.svg',
  bullseye: 'https://openmoji.org/data/color/svg/1F3AF.svg',
  dice: 'https://openmoji.org/data/color/svg/1F3B2.svg',
  circus: 'https://openmoji.org/data/color/svg/1F3AA.svg',
  rocket: 'https://openmoji.org/data/color/svg/1F680.svg',
  lightning: 'https://openmoji.org/data/color/svg/26A1.svg',
  fire: 'https://openmoji.org/data/color/svg/1F525.svg',
  diamond: 'https://openmoji.org/data/color/svg/1F48E.svg',
  fox: 'https://openmoji.org/data/color/svg/1F98A.svg',
  wolf: 'https://openmoji.org/data/color/svg/1F43A.svg',
  lion: 'https://openmoji.org/data/color/svg/1F981.svg',
  tiger: 'https://openmoji.org/data/color/svg/1F42F.svg',
  invader: 'https://openmoji.org/data/color/svg/1F47E.svg',
  robot: 'https://openmoji.org/data/color/svg/1F916.svg',
  alien: 'https://openmoji.org/data/color/svg/1F47D.svg',
  unicorn: 'https://openmoji.org/data/color/svg/1F984.svg',
};

// Fix #6: Whitelist of allowed avatar URL domains — only these are trusted
const ALLOWED_AVATAR_DOMAINS = [
  'openmoji.org',
  'gamestore-be-qt96i.ondigitalocean.app',
  '167.86.82.172',
];

/**
 * Validates an external URL against the domain whitelist.
 * Rejects data: URIs and any domain not in the allowlist.
 */
const isAllowedUrl = (url) => {
  // Fix #6: Reject data: URIs entirely — they can embed arbitrary HTML/SVG
  if (url.startsWith('data:')) return false;

  try {
    const parsed = new URL(url);
    return ALLOWED_AVATAR_DOMAINS.some(
      (domain) => parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
};

export const resolveAvatarUrl = (src) => {
  if (!src) return '';

  // Relative paths (e.g. /avatars/img.png from our own server) are safe
  if (src.startsWith('/')) return src;

  // Check known avatar IDs first
  if (AVATAR_MAP[src]) return AVATAR_MAP[src];

  // For absolute URLs, validate domain before accepting — Fix #6
  if (src.startsWith('http://') || src.startsWith('https://')) {
    return isAllowedUrl(src) ? src : '';
  }

  // Unknown format — reject
  return '';
};

const AvatarImg = ({ src, alt = 'Avatar', className = '', fallback = null }) => {
  const [errored, setErrored] = useState(false);
  const resolvedSrc = resolveAvatarUrl(src);

  // Reset errored state if src changes
  useEffect(() => {
    setErrored(false);
  }, [src]);

  if (!resolvedSrc || errored) {
    if (fallback) {
      return fallback;
    }
    return <span className="text-2xl grayscale opacity-50 select-none">🎮</span>;
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      onError={() => setErrored(true)}
      loading="lazy"
    />
  );
};

export default AvatarImg;
